import getWallet from "./wallet";
import abi from "../abi/xGold.json";
import autorunAbi from "../abi/autorun.json";
import autorun2Abi from "../abi/autorun2.json";
import ownerAbi from "../abi/owner.json";
import bankAbi from "../abi/bank.json";
import busoAbi from "../abi/buso.json";
import autolp from "../abi/autolp.json";
import tokenAbi from "../abi/token.json";
import { ethers } from "ethers";

// Testnet
// const proxyContract = "0x576fD4eE20cD2aFc70D55fb8AB795a976B715094";
// const autoRunProxy = "0x12c2dEeec52ba7033Efb95E4a857e9192B5BF394";
// const autoRun2Proxy = "0x32D94bda5807879e92fe70088a367a12e0fcc5b2";
// const autoRun3Proxy = "0x2eC51ba292F03634FF580ce0239a732Ad1155252";
// const ownerContract = "0x2bE4f6fca9099eB818889d2054715E8DB56C56cB";
// const bankContract = "0xb96A770a3eB4D3410Be2cf176CfF14746D0E3d7f"; 

// Polygon Mainnet
 const proxyContract = "0x347dd5238d70EE89b718059D2ae15c9c6190E15f";
 const autoRunProxy = "0x2Bd1d4f8D012Dd88291D1982ac5958288791A7dC";
 const autoRun2Proxy = "0x0D908223850F5BcbcAe28E86ad445d42e86Ea534";
 const autoRun3Proxy = "0xaeC7Fbd0d4E526d1079dfCE1a7d36f6E3dB8a99e";
 const ownerContract = "0x1F60a921DDF5b1B548761De4c688f80E5a57Ec7d";
 const bankContract = "0x688056677F6b6059d35dE46E07D02C1e02f4F9c4";

// local
// const proxyContract = "0x9fE46736679d2D9a65F0992F2272dE9f3c7fa6e0";
// const autoRunProxy = "0xDc64a140Aa3E981100a9becA4E685f962f0cF6C9";
// const ownerContract = "0x75537828f2ce51be7289709686A69CbFDbB714F1";
// const bankContract = "0x0165878A594ca255338adfa4d48449f69242Eb8F";

const contractCreationBlockNumber = 36878957;

const getContract = async () => {
    const wallet = await getWallet();
    let contract = new ethers.Contract(proxyContract, abi, wallet.provider);
    if (!wallet.isReadOnly) {
        contract = contract.connect(wallet.signer);
    }
    
    return contract;
}

export const getBankContract = async () => {
  const wallet = await getWallet();
  let contract = new ethers.Contract(bankContract, bankAbi, wallet.provider);
  if (!wallet.isReadOnly) {
      contract = contract.connect(wallet.signer);
  }
  
  return contract;
}

export const getAutoRunContract = async () => {
  const wallet = await getWallet();
  let contract = new ethers.Contract(autoRunProxy, autorunAbi, wallet.provider);
  if (!wallet.isReadOnly) {
      contract = contract.connect(wallet.signer);
  }
  
  return contract;
}

export const getAutoRun2Contract = async () => {
  const wallet = await getWallet();
  let contract = new ethers.Contract(autoRun2Proxy, autorun2Abi, wallet.provider);
  if (!wallet.isReadOnly) {
      contract = contract.connect(wallet.signer);
  }
  
  return contract;
}

export const getAutoRun3Contract = async () => {
  const wallet = await getWallet();
  let contract = new ethers.Contract(autoRun3Proxy, autorun2Abi, wallet.provider);
  if (!wallet.isReadOnly) {
      contract = contract.connect(wallet.signer);
  }
  
  return contract;
}


export const getContractCreationBlock = async () => {
    return contractCreationBlockNumber;
}

export const getTotalContractTransactions = async () => {
    try {
      const wallet = await getWallet();
      const transactionCount = await wallet.provider.getTransactionCount(proxyContract);
      console.log("transactionCount: ", transactionCount);
      return transactionCount;
    } catch (error) {
      throw new Error('Failed to retrieve total contract transactions: ' + error.message);
    }
  };

// export const getAutoLpContract = async () => {
//     const wallet = await getWallet();
//     let contract = new ethers.Contract(autoLp, autolp, wallet.provider);
//     if (!wallet.isReadOnly) {
//         contract = contract.connect(wallet.signer);
//     }
//     return contract;
// }

export const getOwnerContract = async () => {
    const wallet = await getWallet();
    let contract = new ethers.Contract(ownerContract, ownerAbi, wallet.provider);
    if (!wallet.isReadOnly) {
        contract = contract.connect(wallet.signer);
    }
    return contract;
}

const token = "0xD69071579ae36c45D63EC2D5d0E82C0a569c2cC3";

export const getTokenContract = async () => {
  const wallet = await getWallet();
  let contract = new ethers.Contract(token, tokenAbi, wallet.provider);
  if (!wallet.isReadOnly) {
      contract = contract.connect(wallet.signer);
  }
  return contract;
}


export default getContract;